import { render, staticRenderFns } from "./cta-banner-originator.vue?vue&type=template&id=ed1eb0de&scoped=true"
import script from "./cta-banner-originator.vue?vue&type=script&lang=js"
export * from "./cta-banner-originator.vue?vue&type=script&lang=js"
import style0 from "./cta-banner-originator.vue?vue&type=style&index=0&id=ed1eb0de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1eb0de",
  null
  
)

export default component.exports